import { ApiResponse } from "../../../../model/common/apiResponse";
import { axiosService, ServiceEndPoint } from "../../../../Services/common/Axios.service";


const INVENTORY_SERVICE_URL=ServiceEndPoint.inventory_service;
const ACCOUNT_SERVICE_URL=ServiceEndPoint.account_service;
const INBOUND_SERVICE_URL=ServiceEndPoint.inbound_service;

export async function getInventoryGeneralInquiryItemDetails(id?:any,params?:any): Promise<ApiResponse<any>> {
    const response = await axiosService.get(`${ACCOUNT_SERVICE_URL}items/${id}?${params}`);
    return response.data;
}

export async function getInventoryGeneralInquiryNoOfLocation(payload:any): Promise<ApiResponse<any>> {
    const response = await axiosService.post(`${INVENTORY_SERVICE_URL}inventories/query`,payload);
    return response.data;
}

export async function getInventoryAvailByInvStatus(payload:any): Promise<ApiResponse<any>> {
    const response = await axiosService.post(`${INVENTORY_SERVICE_URL}inventories/query`,payload);
    return response.data;
}
export async function getInventoryCardexInquiry(payload:any): Promise<ApiResponse<any>> {
    const response = await axiosService.post(`${INVENTORY_SERVICE_URL}inventory-user-events/query`,payload);
    return response.data;
}

export async function getInventoryDetails(payload:any): Promise<ApiResponse<any>> {
    const response = await axiosService.post(`${INVENTORY_SERVICE_URL}inventories/query`,payload);
    return response.data;
}

export async function getReceivingHistory(payload:any): Promise<ApiResponse<any>> {
    const response = await axiosService.post(`${INBOUND_SERVICE_URL}receipt-details/query`,payload);
    return response.data;
}
export async function getInventoryEventHistory(payload:any): Promise<ApiResponse<any>> {
    const response = await axiosService.post(`${INVENTORY_SERVICE_URL}stock-transfer-events/query`,payload);
    return response.data;
}
